import IncTextField from 'components/forms/fields/inc-text-field/inc-text-field.component';
import { useTranslation } from 'react-i18next';
import { useMapsAddress } from '../../address-form.hooks';

const PostalCodeField = ({ name, ...rest }) => {
  const { t } = useTranslation();
  useMapsAddress(name, 'postalCode');

  return (
    <IncTextField
      name={name}
      label={t('forms.fields.postalCode.label')}
      data-testid="PostalCodeField"
      {...rest}
    />
  );
};
export default PostalCodeField;
